var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groups"},[_c('page-header',{attrs:{"title":"Спиcок групп"}}),_c('ol',{staticClass:"groups__list"},_vm._l((_vm.groups),function(group,index){return _c('li',{key:index,staticClass:"list__item"},[_vm._v(" "+_vm._s(group.name)+" ")])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }